import type { InvoiceStatusId } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import { formatNumberToCurrency } from "~/utils/currencyUtils.ts";
import { ThemeName } from "~/utils/themeVariants.ts";


export const invoiceStatusId = {
	Pending: "1",
	Draft: "2",
	AwaitingApproval: "6",
	Approved: "7",
	SentToClient: "3",
	Paid: "4",
	Reversed: "5",
} as const;

export function getInvoiceStatusDisplayNameById(id: InvoiceStatusId, isSelfBilledInvoice= false) {
	switch (id) {
		case invoiceStatusId.Pending:
			return "Offen";
		case invoiceStatusId.Draft:
			return "Angelegt";
		case invoiceStatusId.AwaitingApproval:
			return "Warten auf Freigabe";
		case invoiceStatusId.Approved:
			return "Freigegeben";
		case invoiceStatusId.SentToClient:
			return isSelfBilledInvoice ? "Warten auf Zahlung" : "Versendet / Warten auf Zahlung";
		case invoiceStatusId.Paid:
			return "Bezahlt";
		case invoiceStatusId.Reversed:
			return "Storniert";
		default:
			throw new Error(`Unknown invoice status id: ${id}`);
	}
}

export function getInvoiceStatusThemeById(id: InvoiceStatusId) {
	switch (id) {
		case invoiceStatusId.Draft:
			return ThemeName.Neutral;
		case invoiceStatusId.SentToClient:
			return ThemeName.Primary;
		case invoiceStatusId.Paid:
			return ThemeName.Success;
		case invoiceStatusId.Reversed:
			return ThemeName.Danger;
		case invoiceStatusId.Pending:
			return ThemeName.Neutral;
		default:
			throw new Error(`Unknown invoice status id: ${id}`);
	}
}

export function getFormattedCurrencyValue(valueCents: number, currencySymbol: string) {
	return `${formatNumberToCurrency(valueCents)} ${currencySymbol}`;
}
